import { IPixelStatusKey } from "@interfaces/pixel-map-day.interface";

export type ThemeColors = {
	[key in IPixelStatusKey]: string;
};

export const themeColors: ThemeColors = {
	special: "#e052c2",
	excellent: "#36b9d9",
	good: "#1b82e6",
	"above-average": "#5cc750",
	average: "#f4d44d",
	"below-average": "#f6a543",
	bad: "#e64b3a",
	awful: "#4b2d6e"
};
